import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39851bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/home/dialog.png",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "售前咨询", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "可拨打或添加我们的微信", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, " 将体验到VIP顾问式售前咨询，1v1按需求定制个性化方案，全程360°服务。 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = { class: "qrcode" }
const _hoisted_9 = { class: "img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "tel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      center: "",
      width: "45%",
      onClose: _ctx.dialogClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qrCodeList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(item.name), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(item.tel), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}